export function mapVoices(voices: Array<SpeechSynthesisVoice>) {
    let currentOS: string = '';
    if (navigator.appVersion.indexOf("Win") !== -1) currentOS = "Windows";
    if (navigator.appVersion.indexOf("Mac") !== -1) currentOS = "MacOS";
    if (navigator.appVersion.indexOf("CrOS") !== -1) currentOS = "CrOS";
    let modified = voices.map(item => item.name);
    let voicesList = [];

    if (currentOS === 'MacOS') {
        voicesList.push({abbr: "US Male", name: 'Alex', source: 'lg', type: "native"});
        voicesList.push({abbr: "US Female", name: 'Samantha', source: 'lg', type: "native"});
        voicesList.push({abbr: "UK Male", name: 'Daniel', source: 'lg', type: "native"});
        voicesList.push({abbr: "Hebrew", name: 'Carmit', source: 'lg', type: "native"});
        voicesList.push({abbr: "Russian", name: 'Milena', source: 'lg', type: "native"});
        voicesList.push({abbr: "Japanese", name: 'Kyoko', source: 'lg', type: "native"});
        voicesList.push({abbr: "Hungarian", name: 'Mariska', source: 'lg', type: "native"});
        voicesList.push({abbr: "Italian", name: 'Alice', source: 'lg', type: "native"});
        voicesList.push({abbr: "Spanish (Spain)", name: 'Jorge', source: 'lg', type: "native"});
        voicesList.push({abbr: "Spanish (Mexico)", name: 'Juan', source: 'lg', type: "native"});
        voicesList.push({abbr: "Swedish", name: 'Alva', source: 'lg', type: "native"});
        voicesList.push({abbr: "French Canadian ", name: 'Amelie', source: 'lg', type: "native"});
        voicesList.push({abbr: "German", name: 'Anna', source: 'lg', type: "native"});
    } else if (currentOS === 'CrOS') {
        voicesList.push({abbr: "US Male", name: 'Chrome OS US English', source: 'lg', type: "native"});
        voicesList.push({abbr: "Dutch", name: 'Chrome OS Deutsch', source: 'lg', type: "native"});
        voicesList.push({
            abbr: "Portuguese português do Brasil",
            name: 'Chrome OS português do Brasil',
            source: 'lg',
            type: "native",

        });
        voicesList.push({
            abbr: "Spanish Español",
            name: 'Chrome OS español',
            source: 'lg',
            type: "native",

        });
        voicesList.push({
            abbr: "French français",
            name: 'Chrome OS français',
            source: 'lg',
            type: "native",

        });
        voicesList.push({abbr: "Italian", name: 'Chrome OS italiano', source: 'lg', type: "native"});
        voicesList.push({abbr: "Korean 한국의", name: 'Chrome OS 한국의', source: 'lg', type: "native"});
        voicesList.push({
            abbr: "Dutch Nederlands",
            name: 'Chrome OS Nederlands',
            source: 'lg',
            type: "native",

        });
        voicesList.push({abbr: "Hindi हिन्दी", name: 'Chrome OS हिन्दी', source: 'lg', type: "native"});
        voicesList.push({
            abbr: "Indonesia",
            name: 'Chrome OS Bahasa Indonesia',
            source: 'lg',
            type: "native",

        });
    }

    voicesList.push({abbr: "US English", name: 'Google US English', source: 'google', type: "native"});
    voicesList.push({
        abbr: "UK Female",
        name: 'Google UK English Female',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "UK Male",
        name: 'Google UK English Male',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "Spanish Español",
        name: 'Google español',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "Spanish Mexico Español Méjico",
        name: 'Google español de Estados Unidos',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "French français",
        name: 'Google français',
        source: 'google',
        type: "native",

    });
    voicesList.push({abbr: "Dutch", name: 'Google Deutsch', source: 'google', type: "native"});
    voicesList.push({abbr: "Hindi हिन्दी", name: 'Google हिन्दी', source: 'google', type: "native"});
    voicesList.push({
        abbr: "Indonesia",
        name: 'Google Bahasa Indonesia',
        source: 'google',
        type: "native",

    });
    voicesList.push({abbr: "Italian", name: 'Google italiano', source: 'google', type: "native"});
    voicesList.push({abbr: "Japanese 日本語", name: 'Google 日本語"', source: 'google', type: "native"});
    voicesList.push({abbr: "Korean 한국의", name: 'Google 한국의', source: 'google', type: "native"});
    voicesList.push({
        abbr: "Dutch Nederlands",
        name: 'Google Nederlands',
        source: 'google',
        type: "native",

    });
    voicesList.push({abbr: "Polish Polski", name: 'Google polski', source: 'google', type: "native"});
    voicesList.push({
        abbr: "Portuguese português do Brasil",
        name: 'Google português do Brasil',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "Russian русский",
        name: 'Google русский',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "Mandarin Chinese",
        name: 'Google 普通话（中国大陆）',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "Cantonese Hong Kong",
        name: 'Google 粤語（香港）',
        source: 'google',
        type: "native",

    });
    voicesList.push({
        abbr: "Chinese Taiwanese",
        name: 'Google 國語（臺灣）',
        source: 'google',
        type: "native",

    });
    return voicesList.filter((item) => modified.includes(item.name));

}
